import { useQuery } from 'react-query';
import { devicesEld } from '../../../../API/TT_ELD/Team/devices';

export const useDevicesEld = (
  userId: string | number,
  model: string | number,
  eldVersion: string | number,
  appVersion: string | number,
  versionCode: string | number,
  device: string | undefined,
  searchEldType: string | undefined,
  sort: boolean | undefined | string,
  skip: any,
  companyId?: undefined | number | string,
) => {
  return useQuery(
    [
      `devices/${userId}`,
      userId,
      model,
      eldVersion,
      appVersion,
      versionCode,
      device,
      sort,
      skip,
      searchEldType,
      companyId,
    ],
    () =>
      devicesEld.read(
        userId,
        model,
        eldVersion,
        appVersion,
        versionCode,
        device,
        searchEldType,
        sort,
        skip,
        companyId,
      ),
    { refetchOnWindowFocus: false },
  );
};

export const useFindDeviceName = async (query: string) => {
  return await devicesEld.deviceFinderName(query);
};
